"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
var _reactDateRange = require("react-date-range");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ThemedDateRange = (0, _material.styled)(_material.Box)(function (_ref) {
  var theme = _ref.theme;
  var bg1 = theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.common.white;
  var bg2 = theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[100];
  var bg3 = theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.common.white;
  var disabled = theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[400];
  return {
    '.ThemedDateRange': {
      backgroundColor: bg1,
      '& .rdrDateDisplayWrapper': {
        backgroundColor: bg2
      },
      '& .rdrDateDisplayWrapper .rdrDateDisplay': {
        color: "".concat(theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main, " !important")
      },
      '& .rdrDateDisplayWrapper .rdrDateDisplay .rdrDateInput': {
        backgroundColor: bg3
      },
      '& .rdrDateDisplayWrapper .rdrDateDisplay .rdrDateInput input': {
        color: theme.palette.text.primary
      },
      '& .rdrMonthAndYearWrapper .rdrMonthAndYearPickers select': {
        color: theme.palette.text.primary,
        background: bg1
      },
      '& .rdrMonthAndYearWrapper .rdrMonthAndYearPickers select:hover': {
        background: bg2
      },
      '& .rdrMonthAndYearWrapper button': {
        backgroundColor: bg2,
        color: theme.palette.text.primary
      },
      '& .rdrMonths .rdrWeekDays .rdrWeekDay': {
        color: theme.palette.text.primary
      },
      '& .rdrMonths .rdrDay .rdrDayNumber span': {
        color: theme.palette.text.primary
      },
      '& .rdrMonths .rdrDay.rdrDayPassive .rdrDayNumber span': {
        color: disabled
      }
    }
  };
});
function DateRangeComponent(_ref2) {
  var selectionRange = _ref2.selectionRange,
    locale = _ref2.locale,
    maxDate = _ref2.maxDate,
    minDate = _ref2.minDate,
    onChangeRange = _ref2.onChangeRange;
  return /*#__PURE__*/_react["default"].createElement(ThemedDateRange, {
    pl: 1,
    pt: 1
  }, /*#__PURE__*/_react["default"].createElement(_reactDateRange.DateRange, {
    ranges: [selectionRange],
    onChange: onChangeRange,
    locale: locale,
    maxDate: maxDate,
    minDate: minDate,
    weekStartsOn: 1,
    className: "ThemedDateRange"
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(DateRangeComponent);